// extracted by mini-css-extract-plugin
module.exports =  {"customizedLegend":"customizedLegend__LsDUs","categoryLegendItem":"categoryLegendItem__IDkmQ"};